module.exports = __webpack_public_path__ + "media/newstyle/images/icon-questionmark-orange-4bc59857c0ea134e48bfab8e72ecbf49.svg";